<div class="claim-page">
  <div class="claim-card">
    <div class="header-section">
      <span class="material-symbols-outlined icon-key">vpn_key</span>
      <h1>Claim Your Profile</h1>
      <p>Take over full ownership and login access of your matrimony bio-data from your marriage broker or bureau.</p>
    </div>

    <div *ngIf="success" class="alert-success">
      <span class="material-symbols-outlined">check_circle</span>
      <div>
        <strong>Profile Claimed Successfully!</strong>
        <p>You are now the sole owner of this account. Redirecting to login page...</p>
      </div>
    </div>

    <div *ngIf="error" class="alert-error">
      <span class="material-symbols-outlined">error</span> {{ error }}
    </div>

    <form *ngIf="!success" (ngSubmit)="onSubmit()" class="claim-form">
      <div class="form-group">
        <label>Profile ID or Email</label>
        <input type="text" [(ngModel)]="profileId" name="profileId" placeholder="Paste your Profile ID or Email" class="form-input" required>
        <span class="help-text">You can find your Profile ID on your matrimony profile card or ask your broker.</span>
      </div>

      <div class="form-group">
        <label>6-Digit Handover OTP</label>
        <input type="text" [(ngModel)]="otp" name="otp" placeholder="e.g. 123456" maxlength="6" class="form-input otp-input" required>
        <span class="help-text">Ask your broker to click "Handover OTP" on their dashboard to generate this code.</span>
      </div>

      <button type="submit" class="btn-submit" [disabled]="loading || !profileId || !otp">
        <span class="material-symbols-outlined spin" *ngIf="loading">progress_activity</span>
        <span>{{ loading ? 'Verifying...' : 'Verify OTP & Take Ownership' }}</span>
      </button>
    </form>

    <div class="footer-link">
      <a routerLink="/" class="back-link"><span class="material-symbols-outlined">arrow_back</span> Return to Main Site</a>
    </div>
  </div>
</div>
